import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, Button} from 'reactstrap';
import axios from "axios";
import {serverPath} from "../../common";

class EditLimits extends Component {

    constructor(props) {
        super(props);

        this.state = {
            problem: props.problem
        };

        this.saveChanges = this.saveChanges.bind(this);
    }

    saveChanges() {
        var params = new FormData();
        params.append('action', 'editLimits');
        params.append('problem', JSON.stringify(this.state.problem));
        axios.post(serverPath + "problemsService.php", params)
            .then((response) => {
                this.props.closeModalHandler(this.state.problem);
            });
    }

    handleChange = event => {
        const {name, value} = event.target
        const updatedControls = {
            ...this.state.problem
        };
        updatedControls[name] = value;
        this.setState({ problem: updatedControls });
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={() => this.props.closeModalHandler(null)}>
                <ModalHeader toggle={() => this.props.closeModalHandler(null)}>
                    <h4> Izmena ograničenja </h4>
                </ModalHeader>
                <ModalBody className="">
                    <div className="form-group">
                        <label htmlFor="timeLimit">Vremensko ogranicenje</label>
                        <div className="input-group mb-2 mr-sm-2">
                            <input className="form-control"
                                   id="timeLimit"
                                   name="timeLimit"
                                   type="number"
                                   value={this.state.problem.timeLimit}
                                   onChange={this.handleChange}/>
                            <div className="input-group-append">
                                <div className="input-group-text">ms</div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="memoryLimit">Memorijsko ogranicenje</label>
                        <div className="input-group mb-2 mr-sm-2">
                            <input className="form-control"
                                   id="memoryLimit"
                                   name="memoryLimit"
                                   type="number"
                                   value={this.state.problem.memoryLimit}
                                   onChange={this.handleChange}
                                    step="1048576"/>
                            <div className="input-group-append">
                                <div className="input-group-text">b</div>
                            </div>
                        </div>
                        <label> ={this.state.problem.memoryLimit/1024/1024} MB </label>
                    </div>
                    <Button onClick={this.saveChanges}> Sačuvaj promene </Button>
                    <Button onClick={() => this.props.closeModalHandler(null)}> Odustani </Button>
                </ModalBody>
            </Modal>
        );
    }
}

export default EditLimits;